/*
 *  -----------------------------------------------------------------------
 *    <copyright file="modal-helper.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

export const MODAL_CLOSE_ACTIONS = {
    ERROR: 'error',
    SUCCESS: 'success',
    UNASSIGN: 'unassign',
    SUCCESS_AND_CLOSE: 'success-and-close',
};
